module.exports = __webpack_public_path__ + "static/img/Tom-Papley.aad57b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Papley.jpg
// module id = RH9J
// module chunks = 0